<template>
  <div class="form">
    <div class="form__content">
      <IdentityQueueStepCounter />
      <h1 class="extra-large-headline">
        {{ $t('ZerohashTncForm.label.title') }}
      </h1>
    </div>
    <form
      @submit.prevent>
      <Checkbox
        name="zerohash_tnc"
        :text="
          $t('Checkbox.text.zeroHash', {
            zeroHashLink: `<a target='_blank' href='https://www.zerohash.com/banxa'>${$t(
              'Checkbox.text.zeroHashUserAgreement',
            )}</a>`,
            zerohashLink: `<a target='_blank' href='https://zerohash.zendesk.com/hc/en-us/articles/360009900494-Privacy-Policy-'>${$t(
              'Checkbox.text.zeroHashPrivacyPolicy',
            )}</a>`,
            zendDeskLink: `<a href='https://zerohash.zendesk.com/hc/en-us/articles/360008819314-State-Money-Transmitter-Disclosures' target='_blank'>${$t(
              'Checkbox.text.regulatoryDisclosure',
            )}</a>`,
          })
        "
        v-model:value="form.zerohash_tnc"
        v-model:zerohash_tnc="form.zerohash_tnc"
      />
      <ButtonBase
        :isDisabled="!form.zerohash_tnc || globalStore.getIsFormLoading"
        :isLoading="globalStore.getIsFormLoading"
        @onButtonClick="handleFormSubmit"
      >
        {{ $t('ButtonBase.label.submitMyDetails') }}
      </ButtonBase>
      <IdentityQueueNext />
    </form>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import { useGlobalStore } from '@/stores/globalStore';
import { useIdentityQueueStore } from '@/stores/identityQueueStore';

import useApiHelpers from '@/composables/api/helpers';

import ButtonBase from '@/components/ui/buttons/ButtonBase.vue';
import Checkbox from '@/components/ui/inputs/Checkbox.vue';
import IdentityQueueStepCounter from '@/components/layout/progress/IdentityQueueStepCounter.vue';
import IdentityQueueNext from '@/components/layout/progress/IdentityQueueNext.vue';

const route = useRoute();
const router = useRouter();
const globalStore = useGlobalStore();
const identityQueueStore = useIdentityQueueStore();
const { postRequest } = useApiHelpers();

const emit = defineEmits(['onPrimaryButtonClick', 'onSecondaryButtonClick']);
const props = defineProps({
  mode: {
    type: String,
    default: 'form',
  },
});

const form = ref({
  zerohash_tnc: false,
});

const handleFormSubmit = () => {
  const formData = { name: 'ZEROHASH_TNC', action: 'checked' };
  globalStore.setIsFormLoading(true);
  postRequest(
    '/customer/tnc',
    formData,
    () => {
      if (props.mode === 'modal') {
        emit('onPrimaryButtonClick');
      } else {
        identityQueueStore.updateToNextRoute();
        identityQueueStore.fetchNextIdentityRoute(route).then((nextRoute) => {
          router.push(nextRoute);
        });
      }
    },
    () => {
      if (props.mode === 'modal') emit('onPrimaryButtonClick'); // to close the modal on error
    },
  );
};
</script>

<style lang="scss" scoped>
.form__content {
  padding-bottom: 3rem;
  max-width: 54rem;
  //padding: 0 2rem;

  @include breakpoint($min-m) {
    padding-inline: 0;
  }

  .small-headline {
    color: var(--primary);
    margin-bottom: 1.8rem;
  }
}
</style>
